// Initial state
const state = {
  visible: true,
  items: [
    { icon: 'dashboard', key: 'dashboard', text: 'sidebar.dashboard', routerName: 'Dashboard', roles: ['SUPER_ADMIN'] },
    { icon: 'home', key: 'organizations', text: 'sidebar.organizations', routerName: 'Organizations', roles: ['SUPER_ADMIN'] },
    { icon: 'description', key: 'members', text: 'sidebar.members', routerName: 'Members', roles: ['MEMBER_VIEW', 'MEMBER_EDIT', 'MEMBER_ACCOUNTING'], excludeRoles: ['SUPER_ADMIN'] },
    { icon: 'supervisor_account', key: 'users', text: 'sidebar.users', routerName: 'Users', roles: ['ADMIN'] },
    { icon: 'settings', key: 'configuration', text: 'sidebar.configuration', routerName: 'Configuration', roles: ['ADMIN'] }
  ]
}

// Mutations
const mutations = {
  toggleVisible (state, userContext) {
    state.visible = !state.visible
  }
}

// Actions
const actions = {
  toggle ({ commit, state }) {
    commit('toggleVisible')
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/sidebar.js